import { api } from '@/api/client';

/** Mirrors App\Http\Controllers\Api\V1\Address\AddressLookupController. */
export interface AddressLookup {
  /**
   * Whether the postcode could be checked at all.
   *
   * False means the market is unsupported or the lookup service was
   * unreachable — NOT that the postcode is wrong. The UI must stay silent in
   * that case rather than accuse the customer of a mistake it cannot prove.
   */
  checked: boolean;
  exists: boolean;

  postcode: string | null;
  cities: string[];
  suggestedCity: string | null;
  region: string | null;
  regionCode: string | null;
}

export const addressKeys = {
  lookup: (country: string, postcode: string) => ['address', 'lookup', country, postcode] as const,
};

export function lookupPostcode(country: string, postcode: string): Promise<AddressLookup> {
  return api.get<AddressLookup>('/address/lookup', { country, postcode });
}
